const PLACEHOLDER_SVG = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'%3E%3Crect fill='%23f5f0e6' width='400' height='300'/%3E%3Ctext x='200' y='140' text-anchor='middle' fill='%23d4a353' font-size='48' font-family='sans-serif'%3E%F0%9F%90%9D%3C/text%3E%3Ctext x='200' y='180' text-anchor='middle' fill='%23aaa' font-size='14' font-family='sans-serif'%3EKein Bild verfügbar%3C/text%3E%3C/svg%3E`;

export const handleImageError = (e) => {
    e.target.src = PLACEHOLDER_SVG;
    e.target.style.objectFit = 'cover';
};

export default PLACEHOLDER_SVG;
